import React, { useState } from "react";
import "../doctor/components/allpages.css";
import Header from "../../layouts/admin/AdminHeader";
import TabPanel from '@mui/lab/TabPanel';
import TabContext from '@mui/lab/TabContext';
import { CardDetails } from "./components/CardDetails";
import path from "../../path";
import { createAuditLogs } from "../../api/providerApi/providerApi";
import useHeaders from "../../helpers/useHeaders";
import useEncryption from "../../services/useEncryption";
import { useSelector } from "react-redux";
import { selectAuth } from "../../redux/slice/authSlice";
import { toast } from "react-toastify";

export const CardsList = () => {
  const headers = useHeaders();
  const { encryptData, decryptData } = useEncryption();
  const [ search, setSearch ] = useState('');
  const { selctedId } = useSelector(selectAuth);

  const downloadCSVFile = async () => {
    try {
      if(selctedId.length == 0){
        toast.error("Please select some records to export in CSV File.");
        return
      }
      window.location.href = `${path}/v1/transactions/gen-trans-file?records=${encodeURIComponent(encryptData(selctedId))}`;
      let obj = {
        event : 'SuperAdmin has download the CSV file for the transaction list.'
      }
      await createAuditLogs({ data: encryptData(obj)}, headers);
    } catch (error) {
      console.error("Error fetching doctors:", error);
    }
  };

  return (
    <div>
      <Header pageTitle="Card Details" />
      <div className="cardOuter">
        <div className="cardheads">
          <div className="cardTitle"></div>
          
        </div>
        <div className="cardcontents">
          <TabContext className="tabsDesigns">

            <TabPanel className="tabpanelControl">
              <div className="topsearchs">
                <div className="d-flex align-items-center justify-content-between">
                  <div className="searchBar">
                    <input
                      type="text"
                      autoComplete="off"
                      placeholder="Search"
                      value={search}
                      onChange={(e)=>{
                        setSearch(e.target.value)
                      }}
                    />
                  </div>
                  <button className="btn blackoutlineBtn" onClick={downloadCSVFile} >Download CSV</button>
                </div>
                <CardDetails search={search} />
              </div>
            </TabPanel>
          </TabContext>
        </div>
      </div>
    </div>
  );
};
